import { NumberFormatter, Text } from "@mantine/core";

import type { MantineColor, MantineSize, NumberFormatterProps } from "@mantine/core";
import type { FC } from "react";

export type NumberTextProps = {
  c?: MantineColor;
  size?: MantineSize;
  suffix?: string;
  value: number;
} & NumberFormatterProps;

export const NumberText: FC<NumberTextProps> = ({ c, size = "lg", suffix, value, ...props }) => (
  <Text c={c} size={size}>
    <NumberFormatter value={value} {...props} />
    {suffix}
  </Text>
);
